function CheckBox({labelText, isChecked, buttonChecked, id}) {

    const handleChecked = () => {
        buttonChecked(labelText)
    }

    return (
        <div className="quizRadioButton">
            <input type="checkbox" checked={isChecked} onChange={handleChecked} id={"cb-" + id}/> 
            <label htmlFor={"cb-" + id} >{<div className="pl-1 pr-1 "
                                                            dangerouslySetInnerHTML={{__html: labelText}}
                                                        /> } </label>
        </div>
    )
}

export default CheckBox